import { useEffect } from "react";

import { trackEvents } from "app/components/ChangeSolutionModal/hooks/utils";
import { changeSolutionSteps } from "app/components/ChangeSolutionModal/consts";

import { SolutionSelectionStep } from "./screens/solutionStep/SolutionSelectionStep";
import { DefaultSuccessScreen } from "./screens/success/DefaultSuccessScreen";
import { NewSolutionSuccessScreen } from "./screens/success/NewSolutionSuccessScreen";
import { WelcomeScreen } from "./screens/WelcomeScreen";
import type { IStepConfig, IUseCaseStepConfig } from "./types";

export interface IChangeSolutionFlow {
    currentStepConfig: IStepConfig;
    selectedSolution?: IUseCaseStepConfig;
    defaultSolution: IUseCaseStepConfig | null;
    onSelectedSolutionChange: (selection: IUseCaseStepConfig) => void;
}
export const ChangeSolutionFlow = ({
    currentStepConfig,
    selectedSolution,
    defaultSolution,
    onSelectedSolutionChange,
}: IChangeSolutionFlow) => {
    useEffect(() => {
        trackEvents("open", currentStepConfig.trackingEventName);
    }, [currentStepConfig.trackingEventName]);

    const renderCurrentScreen = () => {
        const { id } = currentStepConfig;
        switch (id) {
            case changeSolutionSteps.welcome:
                return <WelcomeScreen config={currentStepConfig} />;
            case changeSolutionSteps.useCase:
                return (
                    <SolutionSelectionStep
                        selectedSolution={selectedSolution}
                        onSelectedSolutionChange={onSelectedSolutionChange}
                        defaultSolution={defaultSolution}
                        config={currentStepConfig}
                    />
                );
            case changeSolutionSteps.currentSolution:
                return <DefaultSuccessScreen config={currentStepConfig} />;
            case changeSolutionSteps.newSolution:
                return <NewSolutionSuccessScreen config={currentStepConfig} />;
            default:
                return <WelcomeScreen config={currentStepConfig} />;
        }
    };

    return renderCurrentScreen();
};
